<div class="container-fluid position-absolute top-0 start-0" *ngIf="IsLoaded">
    <div class="row justify-content-center">
        <div class="col-12 p-0">
            <div class="wrap d-md-flex">
                <div class="text-wrap p-4 p-lg-5 text-center bg-image sm-d-none">
                    <div class="text w-100">
                        <img _ngcontent-mni-c72="" src="assets/images/tetherfi-logo-round.png" width="60" height="60"
                            alt="">
                        <h6 class="mt-2 text-white font-montasara font-login-h3">{{this.welcomeToLabel}}</h6>
                        <h5 class="mt-2 text-white font-montasara font-login-h2">
                            {{ this.productNameLabel}}</h5>
                    </div>
                </div>
                <div class="login-wrap p-4 p-lg-5" *ngIf="IsReady">
                    <div class="d-flex">
                        <div class="w-100 mt-5 mob-position text-center">
                            <img _ngcontent-mni-c72="" src="assets/images/tetherfi-logo-round.png" class="md-d-none"
                                width="60" height="60" alt="">
                            <h3 class="mb-4 text-center font-montasara">{{this.signInLabel}}</h3>
                        </div>
                        <div class="additionalIconsRight">
                            <div class="text-primary">
                                <i class="fa fa-wifi" title="Server Connection Status" data-bs-toggle="tooltip"
                                    data-bs-placement="top" [ngClass]="connectionStatus" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <form action="#" class="signin-form">
                        <div class="form-group mb-3">

                            <div class="face-login-video-container" *ngIf="IsReady && isFaceAuthLoginEnabled()">
                                <video id="___face-login-video-element" [srcObject]="localVideoStream" autoplay
                                    muted></video>
                            </div>

                            <label class="label ms-4" for="name">{{this.supervisorIdLabel}}</label>

                            <input id="lanId" [(ngModel)]="supervisorLanId" type="text"
                                [disabled]="connectionStatus != 'text-success'? true: false"
                                class="form-control text-break" name="username" maxlength="30"
                                placeholder="{{this.lanidLabel}}" autocomplete="off">
                        </div>
                        <div class="form-group">
                            <button type="submit" (click)="login()" [disabled]="IsLoginDisabled"
                                class="form-control btn btn-primary submit px-3">{{this.signInLabel}}</button>
                        </div>
                    </form>

                    <div class="text-center w-100 position-absolute bottom-0 right-0">
                        {{this.copyrightLabel}} {{ this.packageInfo.version }}</div>
                </div>
            </div>
        </div>
    </div>
</div>